// Debug and development
export const nodeEnv = process.env.NODE_ENV
export const isDevelopment = Boolean(nodeEnv === 'development' && process.env.SITE_URL?.includes('localhost'))
export const skipAuthentication = process.env.SKIP_AUTHENTICATION === 'true'
export const isRpaOptionRequired = process.env.RPA_REQUIRED ?? false
export const isProduction = process.env.IS_PRODUCTION === 'true' ? 'true' : 'false'
// Services URLs (public, non-sensitive)
export const dbOperatorUrl = process.env.DB_OPERATOR_FA_URL ?? ''
export const resourceManagerUrl = process.env.RESOURCE_MANAGER_FA_URL ?? ''
export const createVmsUrl = process.env.CREATE_VMS_FA_URL ?? ''
export const apiMUrl = process.env.APIM_URL ?? ''
export const getCloudDetailsFunctionUrl = process.env.GET_CLOUD_DETAILS_FA_URL ?? ''
export const getPMCFunctionUrl = process.env.GET_PMC_FA_URL ?? ''
export const getServiceNowServicesUrl = process.env.GET_SNOW_FA_URL ?? ''
export const keyVaultServiceUrl = process.env.KEY_VAULT_SERVICE_URL ?? ''
export const decommVmsUrl = process.env.DECOM_RESOURCE_FA_URL ?? ''
export const gcpUtilsBaseUrl = process.env.GCP_UTILS_BASE_URL ?? ''
export const automatedChangeEngineUrl = process.env.AUTOMATED_CHANGE_ENGINE_URL ?? ''
export const automatedChangeEngineAudience = process.env.AUTOMATED_CHANGE_ENGINE_AUDIENCE ?? ''
export const saasheader = process.env.SAAS_HEADER ?? ''
export const sendHttpEmailUri = process.env.SEND_HTTP_EMAIL_URI ?? ''
// Frontend environment values are baked into the Gatsby bundle.
export const btpApiGatewayUrl = process.env.BTP_API_GATEWAY_URL ?? ''
// Auth (public, non-sensitive)
export const authClientId = process.env.AUTH_CLIENT_ID ?? ''
export const authAuthority = process.env.AUTH_AUTHORITY ?? ''
export const authRedirectUri = process.env.AUTH_REDIRECT_URI ?? ''
export const authCacheLocation = process.env.AUTH_CACHE_LOCATION ?? 'localStorage'
// FinOps Dashboard (public URLs)
export const co2dashboard = process.env.CO2_URL ?? ''
export const turbo = process.env.TURBO_URL ?? ''
// AgentOps
export const githubOrgRequestUrl = process.env.GITHUB_ORG_REQUEST_URL ?? 'https://unilever.service-now.com/esc?id=sc_cat_item&sys_id=d588feb01b5c861865a06397b04bcb86&table=sc_cat_item&searchTerm=devops'
export const aiAssuranceApprovalLink = process.env.AI_ASSURANCE_APPROVAL_LINK ?? ''
export const designBoardApprovalLink = process.env.DESIGN_BOARD_APPROVAL_LINK ?? ''
// Hybrid Parking Dashboard
export const hybridParkingFunctionUrl = process.env.HYBRID_PARKING_FA_URL ?? ''
// Hybrid Parking - STS scope (environment-specific identifiers, not secrets)
export const stsErpFolderId = process.env.STS_ERP_FOLDER_ID ?? '662101521365'
export const stsAzureSubscriptionIds = process.env.STS_AZURE_SUBSCRIPTION_IDS ?? '61f1b943-e15f-42a1-b3e4-a098cb2826e1,1c0c41e9-8fe8-4ae8-b996-5a1dd1cd7701,42d55838-585f-4a26-b055-3b7c78326ebc,4c18ce9f-e28d-4f9b-966f-ebe469a1123b,6c76103f-b987-4d6b-8f8d-b251cb88ffbb,12720bd2-bf43-4d35-b9da-7bf1e94dcab0,ffe21446-3735-45d8-b01b-4d85a22a455b'
export const overrideMaxHours = 120
// Migration Dashboard
export const migrationServiceUrl = process.env.MIGRATION_SERVICE_FA_URL ?? apiMUrl ?? ''
export const migrationManagerRoute = process.env.MIGRATION_MANAGER_ROUTE ?? ''
// M2VM (VM Migration)
export const m2vmProjectId = process.env.M2VM_PROJECT_ID ?? ''
// ServiceNow Base URL
export const serviceNowBaseUrl = process.env.SERVICENOW_BASE_URL ?? 'https://unilevertest.service-now.com'

// GCP Orchestrator configuration - MOVED TO BACKEND ONLY
// These values are sensitive infrastructure identifiers and should not be in frontend config
// Frontend will fetch them from /api/orca/config endpoint when needed
// NOTE: Removed exports: orcaUrl, orcaAppUri, orcaWifAudience, orcaCallerSa

// SECURITY NOTE: Subscription keys have been removed from this file.
// They are now managed server-side in Azure Function App Settings.
// Use secureApi from services/secureApiClient.ts for API calls.
//
// ⛔ NEVER export credentials in frontend code:
// - ORCA_GCP_BEARER_CLIENT_ID
// - ORCA_GCP_BEARER_CLIENT_SECRET
// - ORCA_GCP_BEARER_CLIENT_SCOPE
// - ORCA_GCP_BEARER_CLIENT_GRANT
// - BTP_CLIENT_ID
// - BTP_CLIENT_SECRET
// - AZURE_CLIENT_ID
// - AZURE_CLIENT_SECRET
//
// These secrets are ONLY for backend use. The frontend should call:
// - /api/azure/bearerToken for Azure OAuth tokens
// - /api/gcp/bearerToken for GCP bearer tokens
// - /api/proxy for authenticated API calls
